"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 18.1",
    width: "24",
    height: "18.1"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M5,18.1c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S6.4,18.1,5,18.1z M5,14.1 c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S5.8,14.1,5,14.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M19,18.1c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S20.4,18.1,19,18.1z M19,14.1 c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S19.8,14.1,19,14.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M17,16.1H7c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h10c0.3,0,0.5,0.2,0.5,0.5S17.3,16.1,17,16.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M4.5,9.1c-0.1,0-0.2,0-0.2-0.1C4,9,3.9,8.7,4.1,8.4l1.5-3C5.6,5.2,5.8,5.1,6,5.1h1.5C7.8,5.1,8,5.4,8,5.6 S7.8,6.1,7.5,6.1H6.3L4.9,8.9C4.9,9,4.7,9.1,4.5,9.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M3,16.1H0.5c-0.3,0-0.5-0.2-0.5-0.5v-5.5C0,10,0.1,9.9,0.1,9.8l2-2l2.5-4.4C4.7,3.2,4.8,3.1,5,3.1h4.5 c0.3,0,0.5,0.2,0.5,0.5v10c0,0.3-0.2,0.5-0.5,0.5S9,13.9,9,13.6V4.1H5.3L2.9,8.4c0,0-0.1,0.1-0.1,0.1L1,10.3v4.8h2 c0.3,0,0.5,0.2,0.5,0.5S3.3,16.1,3,16.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M23.5,16.1H21c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2v-1H0.5c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5 h23c0.3,0,0.5,0.2,0.5,0.5v2C24,15.9,23.8,16.1,23.5,16.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M23.5,14.1h-14c-0.3,0-0.5-0.2-0.5-0.5v-3c0-0.3,0.2-0.5,0.5-0.5h14c0.3,0,0.5,0.2,0.5,0.5v3 C24,13.9,23.8,14.1,23.5,14.1z M10,13.1h13v-2H10V13.1z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    fill: "#9ECE06",
    cx: "16.7",
    cy: "4.3",
    r: "4.3"
  }));
};

exports["default"] = _default;